// extracted by mini-css-extract-plugin
export default {"title":"kDQqgBXzLgUijZIRNtKU","content":"H_CdMrIvtaQ71C_EhkDN","tree_box":"T1zp3jplsL8GvPav__5u","table_box":"DCbVdem3X0siUqe0nTKs"};